import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing(2)};
  background-color: ${theme.colors.neutral[10]};
`;

export const headingStyle = css`
  margin: 0;
`;

export const valueStyle = css`
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  min-height: 0;
  padding-right: ${theme.spacing(1)};
  white-space: pre-wrap;
`;
